// extracted by mini-css-extract-plugin
export default {"body":"HiglightedAddress_body__akEa-","profile":"HiglightedAddress_profile__FJfu5","address":"HiglightedAddress_address__bOwh6"};